import { getIndexName } from '../../constants';
import { createAlgoliaBrowserLiteClient } from './create-browser-algolia-lite-client';

export function getSearchClient() {
  if (typeof window === 'undefined') {
    throw new Error('getSearchClient() can only be called on the client side.');
  }
  const appId = import.meta.env.PUBLIC_ENV__ALGOLIA_APP_ID;
  if (!appId) {
    throw new Error('PUBLIC_ENV__ALGOLIA_APP_ID is required for search.');
  }
  return createAlgoliaBrowserLiteClient(String(appId));
}

export function getIndex(locale: string) {
  const client = getSearchClient() as any;
  const indexName = getIndexName(locale);
  return client.initIndex(indexName);
}

export async function fetchJobsByObjectIDs(locale: string, objectIDs: string[]): Promise<any[]> {
  if (!objectIDs.length) return [];
  const index = getIndex(locale);
  const res = await index.getObjects(objectIDs);
  const results: any[] = Array.isArray(res.results) ? res.results.filter(Boolean) : [];
  return results;
}
